<!--头部-->
<template>
    <div class="contain">
        <div class="logo-contain">
            <div class="icon">
                <!-- <el-image class="logo-img"
                    :src="require('@/assets/logo.png')"
                    fit="fill"></el-image> -->
            </div>
            <div class="logo-title">
                心光
            </div>
        </div>
        <div class="menu-contain">
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    {{ getLangName(lang) }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="lang != 'zh-CN'" command="zh-CN">
                        {{ getLangName('zh-CN') }}
                    </el-dropdown-item>
                    <el-dropdown-item v-if="lang != 'zh-TW'" command="zh-TW">
                        {{ getLangName('zh-TW') }}
                    </el-dropdown-item>
                    <el-dropdown-item v-if="lang != 'en'" command="en">
                        {{ getLangName('en') }}
                    </el-dropdown-item>
                    <el-dropdown-item v-if="lang != 'ja'" command="ja">
                        {{ getLangName('ja') }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-menu :default-active="defaultActive" class="el-menu-header" mode="horizontal" text-color="#000"
                :router="true">
                <el-menu-item index="/">{{ $t('header.home') }}</el-menu-item>
                <el-menu-item index="/about">{{ $t('header.about') }}</el-menu-item>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Header',
    data() {
        return {
            defaultActive: this.$route.path,
            lang: "",
            langList: [
                { value: 'zh-CN', label: '简体中文' },
                { value: 'zh-TW', label: '繁體中文' },
                { value: 'en', label: 'English' },
                { value: 'ja', label: '日本語' },
            ]
        }
    },
    created() {
        this.lang = window.localStorage.getItem("lang");
    },
    mounted() {
        if (!this.lang) {
            console.log('自动语言')
            this.autoLang();
        }
    },
    methods: {
        //初始化语言信息
        autoLang() {
            //先从换从中获取语言
            let lang = window.localStorage.getItem("lang");
            if (lang) {
                this.$i18n.locale = lang;
            } else {
                //如果获取不到，则根据浏览器语言设置
                switch (navigator.language) {
                    case "zh-CN":
                        this.$i18n.locale = "zh-CN";
                        window.localStorage.setItem("lang", "zh-CN");
                        break;
                    case "zh-TW":
                        this.$i18n.locale = "zh-TW";
                        window.localStorage.setItem("lang", "zh-TW");
                        break;
                    case "en":
                        this.$i18n.locale = "en";
                        window.localStorage.setItem("lang", "en");
                        break;
                    case "ja":
                        this.$i18n.locale = "ja";
                        window.localStorage.setItem("lang", "ja");
                        break;
                    default:
                        this.$i18n.locale = "en";
                        window.localStorage.setItem("lang", "en");
                        break;
                }
            }
        },
        handleCommand(lang) {
            console.log(lang);
            this.lang = lang;
            window.localStorage.setItem("lang", lang);
            this.$i18n.locale = lang;
        },
        //获取语言名称
        getLangName(lang) {
            for (let i = 0; i < this.langList.length; i++) {
                if (this.langList[i].value == lang) {
                    return this.langList[i].label;
                }
            }
        }
    },
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 730px) {
    .contain {
        padding: 20px 0;
        width: 100%;
        height: 60px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;

        .logo-contain {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0 0 60px;
            gap: 15px;

            .icon {
                .logo-img {
                    width: 55px;
                    height: 55px;
                }
            }

            .logo-title {
                font-size: 36px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                font-style: italic;
                font-family: "youshebiaoti";
            }

        }

        .menu-contain {
            display: flex;
            align-items: center;
            margin: 0 60px 0 0;

            .el-menu-header {
                display: flex;
                gap: 50px;
                border: 0 !important;
                font-weight: 800;
            }

            .el-menu-item {
                font-size: 18px;
                border-bottom: none !important;
            }

            .is-active {
                position: relative;
                text-align: center;
                border-bottom: none !important;
            }

            .is-active:after {
                content: "";
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                width: 40%;
                /* 控制边框的长度 */
                border-bottom: 4px solid #ee8970;
                /* 控制边框的样式 */
                height: 0;
                border-radius: 10px;
            }
        }
    }
}

@media screen and (max-width: 730px) {
    .contain {
        padding: 10px 0;
        width: 100%;
        height: 60px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;

        .logo-contain {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0 0 20px;
            gap: 10px;

            .icon {
                .logo-img {
                    width: 50px;
                    height: 50px;
                }
            }

            .logo-title {
                font-size: 24px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                font-style: italic;
                font-family: "youshebiaoti";
            }

        }

        .menu-contain {
            margin: 0 0px 0 0;

            .el-menu-header {
                display: flex;
                gap: 10px;
                border: 0 !important;
                font-weight: 800;
            }

            .el-menu-item {
                font-size: 14px;
                border-bottom: none !important;
            }

            .is-active {
                position: relative;
                text-align: center;
                border-bottom: none !important;
            }

            .is-active:after {
                content: "";
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                width: 40%;
                /* 控制边框的长度 */
                border-bottom: 4px solid #ee8970;
                /* 控制边框的样式 */
                height: 0;
                border-radius: 10px;
            }
        }
    }
}

@media screen and (max-width: 430px) {
    .contain {
        padding: 10px 0;
        width: 100%;
        height: 60px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;

        .logo-contain {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0 0 20px;
            gap: 10px;

            .icon {
                .logo-img {
                    width: 50px;
                    height: 50px;
                }
            }

            .logo-title {
                display: none;
            }

        }

        .menu-contain {
            margin: 0 0px 0 0;

            .el-menu-header {
                display: flex;
                gap: 10px;
                border: 0 !important;
                font-weight: 800;
            }

            .el-menu-item {
                font-size: 14px;
                border-bottom: none !important;
            }

            .is-active {
                position: relative;
                text-align: center;
                border-bottom: none !important;
            }

            .is-active:after {
                content: "";
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                width: 40%;
                /* 控制边框的长度 */
                border-bottom: 4px solid #ee8970;
                /* 控制边框的样式 */
                height: 0;
                border-radius: 10px;
            }
        }
    }
}
</style>